import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { TranslateService } from "@ngx-translate/core";
import * as config from "../../../assets/grid_config.json";

@Component({
  selector: "app-partner-list",
  templateUrl: "./partner-list.component.html",
  styleUrls: ["./partner-list.component.css"],
})
export class PartnerListComponent implements OnInit {
  shimarStatus = true;
  partnerList = [];
  gridConfig: any = (config as any).default;
  param = { limit: 20, offset: 0 };
  loadMore: boolean;
  count: any;
  constructor(
    private service: BaseService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.getPartnerList();
  }

  getPartnerList() {
    this.service.partnerList(this.param).subscribe((data: any) => {
      if (data.results.length > 0) {
        this.count = data.counts;
        this.partnerList = data.results;
        this.shimarStatus = false;
        this.loadMore = false;
      } else {
        this.loadMore = false;
      }
    });
  }
  onScroll() {
    const offset = this.param.limit + this.param.offset;
    if (this.count > offset) {
      this.loadMore = true;
      this.param.offset = this.param.limit + this.param.offset;
      this.getPartnerList();
    }
  }
}
